import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { formikEditUser, genderOptions } from '../Constant';
import { useDispatch, useSelector } from 'react-redux';
import { useGetStates } from '../../../hooks/useGetStates';
import Loader from '../../../components/Loader/Loader';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import "./Users.css";
import { updateSuperAdminUser } from '../../../api/User';
import { failed, success } from '../../../utils/Tostify';
import moment from 'moment';
import DatePickerSelector from '../../../components/InputFields/DatePicker';

const EditUser = ({ setShowModal, refetch, userData }) => {
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [Countryvalue, setCountryValue] = useState();
  const [stateValue, setStateValue] = useState();
  const { states, countryOptions } = useGetStates(Countryvalue);

  const formik = useFormik({
    ...formikEditUser,
    onSubmit: async (values) => {
      let res;
      try {
        // values.roles = roleOptions.filter(option => values.roles.includes(option.label));
        // return;
        setIsLoading(true);
        res = await updateSuperAdminUser({ values, dispatch, token, userId: userData?._id });
        if (res?.status == "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          refetch();
          setShowModal();
          // setCurrentTab("userListing");
        } else {
          setIsLoading(false);
          setShowModal();
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const CountrychangeHandler = e => {
    setCountryValue(e.target.value);
    formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
  };

  const stateHandler = (e) => {
    setStateValue(e.target.value);
    formik.setFieldValue('state', e.target.value);
  };
  useEffect(() => {
    if (setShowModal) {
      const modalBody = document.querySelector('.assign_modal_body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }
  }, [setShowModal]);
  useEffect(() => {
    formik.setFieldValue("firstName", userData?.firstName);
    formik.setFieldValue("lastName", userData?.lastName);
    formik.setFieldValue("email", userData?.email);
    formik.setFieldValue("gender", userData?.gender);
    formik.setFieldValue("dob", moment(userData?.dob).format("MM-DD-YYYY") );
    formik.setFieldValue("role", userData?.role);
    // formik.setFieldValue("orgId", userData?.defaultLogInOrg);
    // formik.setFieldValue("hospitalAccess", userData?.defaultLogInOrg);
    formik.setFieldValue("jobTitle", userData?.jobTitle);
    formik.setFieldValue("primaryPhone", userData?.primaryPhone);
    formik.setFieldValue("secondaryPhone", userData?.secondaryPhone);
    formik.setFieldValue("city", userData?.city);
    formik.setFieldValue("address", userData?.address);
    formik.setFieldValue("postalCode", userData?.postalCode);
    formik.setFieldValue("country", userData?.country);
    formik.setFieldValue("employer", userData?.employer);
    formik.setFieldValue("department", userData?.department);
    // formik.setFieldValue("roles", userData?.roles);
    setCountryValue(countryOptions?.find((obj) => obj.label === userData?.country)?.value);
    formik.setFieldValue("state", userData?.state);
    setStateValue(userData?.state);
  }, [userData]);

  return (
    <Fragment>
      <Modal isOpen={setShowModal} toggle={setShowModal} size="xl">
        <Form onSubmit={formik.handleSubmit}>
          <ModalHeader toggle={setShowModal} className="assign_blk p-0 mb-3">Edit User</ModalHeader>
          <ModalBody className="assign_modal_body">
            {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_blk p-0 m-0 organization_modal modal_change_color">
              <div className="forms_block  modal_change_color p-4" style={{gap:'0'}}>
                <div className="first_block">
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"firstName"}
                        formik={formik}
                        label="First Name"
                        type="text"
                        placeholder="First Name"
                        value={formik.values.firstName}
                        onChange={(e) => formik.setFieldValue("firstName", e.target.value)}
                        autoFocus={true}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"lastName"}
                        formik={formik}
                        label="Last Name"
                        placeholder={"Last Name"}
                        type="text"
                        value={formik.values.lastName}
                        onChange={(e) => formik.setFieldValue("lastName", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"gender"}
                        formik={formik}
                        label="Gender"
                        type="select"
                        options={genderOptions}
                        placeholder="gender"
                        value={formik.values.gender}
                        onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block modal_pro_file">
                      <DatePickerSelector
                        keyField={"dob"}
                        formik={formik}
                        value={formik.values?.dob}
                        minDate={""}
                        maxDate={moment()}
                        label="Date Of Birth"
                        type="date"
                        onChange={(e) => formik.setFieldValue("dob", moment(e).format("MM-DD-YYYY"))}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block">
                  <h6 className="block_name">Contact Information</h6>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"email"}
                        formik={formik}
                        label="Email"
                        type="email"
                        placeholder="Email"
                        readOnly={true}
                        value={formik.values.email}
                        onChange={(e) => formik.setFieldValue("email", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"primaryPhone"}
                        formik={formik}
                        label="Mobile Phone Number"
                        type="phone"
                        placeholder="Mobile Phone Number"
                        value={formik.values.primaryPhone}
                        onChange={(e) => formik.setFieldValue("primaryPhone", e)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"secondaryPhone"}
                        formik={formik}
                        label="Secondary Phone Number"
                        type="phone"
                        placeholder="Secondary Phone Number"
                        required={false}
                        value={formik.values.secondaryPhone}
                        onChange={(e) => formik.setFieldValue("secondaryPhone", e)}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block second_block">
                  <h6 className="block_name"> Address Information</h6>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"address"}
                        formik={formik}
                        required={false}
                        label="Street"
                        type="text"
                        placeholder="Street"
                        value={formik.values.address}
                        onChange={(e) => formik.setFieldValue("address", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"country"}
                        formik={formik}
                        options={countryOptions}
                        label="Country"
                        type="select"
                        // placeholder="Country"
                        value={Countryvalue}
                        onChange={CountrychangeHandler}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"state"}
                        formik={formik}
                        label="State"
                        options={states.map((obj) => {
                          return {
                            label: obj.name,
                            value: obj.name
                          };
                        })}
                        type="select"
                        placeholder="State"
                        value={stateValue}
                        onChange={stateHandler}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"city"}
                        formik={formik}
                        label="City"
                        type="text"
                        placeholder="City"
                        value={formik.values.city}
                        onChange={(e) => formik.setFieldValue("city", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"postalCode"}
                        formik={formik}
                        label="Zip Code"
                        type="text"
                        placeholder="Zip Code"
                        value={formik.values.postalCode}
                        onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block second_block">
                  <h6 className="block_name"> Employer Information</h6>
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"employer"}
                        formik={formik}
                        label="Employer Name"
                        type="text"
                        placeholder="Employer Name"
                        value={formik.values.employer}
                        onChange={(e) => formik.setFieldValue("employer", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"department"}
                        formik={formik}
                        label="Department Name"
                        type="text"
                        placeholder="Department Name"
                        value={formik.values.department}
                        onChange={(e) => formik.setFieldValue("department", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"jobTitle"}
                        formik={formik}
                        label="Job Title"
                        type="text"
                        placeholder="Job Title"
                        value={formik.values.jobTitle}
                        onChange={(e) => formik.setFieldValue("jobTitle", e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="p-0 mt-3">
            <div className="d-flex justify-content-between">
              <button className="save_btn" onClick={setShowModal}>Close</button>
              <button className="save_btn" type="submit">Save</button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditUser;
